import React, { useEffect, useState } from 'react'
import { Button } from 'semantic-ui-react'
import styled from 'styled-components'

import { useAuthApi, useTalentApi } from '../../store/mainContext'
import TrEditButton from './trEditButton'
import TrCopyButton from './trCopyButton'
import UserSelect from '../form/userSelect'
import { User } from '../../types'

const UserImage = styled.img`
  border-radius: 30px;
  height: 30px;
  margin-left: 5px;
  margin-right: 10px;
`

const UserName = styled.div`
  display: flex;
  align-items: center;
`

interface Props {
  name: string
  label: string
  placeholder?: string
  value: any
  url: string
  divider?: boolean
  onSuccess?(name: string, value?: Props['value']): void
}

const TrUserSelect = ({
  name,
  label,
  placeholder,
  value,
  onSuccess,
  url,
  divider,
}: Props) => {
  const authApi = useAuthApi()
  const api = useTalentApi()

  const [showEdit, setShowEdit] = useState(false)

  const [editMode, setEditMode] = useState(false)
  const [val, setVal] = useState(value)
  const [showAdd, setShowAdd] = useState(false)

  const [displayValue, setDisplayValue] = useState<User | null>(null)

  const [isLoading, setIsLoading] = useState(false)

  const [, setCancelOnBlur] = useState(false)

  const refreshDisplayValue = React.useCallback(
    async (newvalue?: User['_id']) => {
      if (!newvalue) {
        setDisplayValue(null)
        return
      }
      const { data } = await authApi.get<User>(`users/${newvalue}`)
      setDisplayValue(data)
    },
    [authApi],
  )

  useEffect(() => {
    setVal(value)
    refreshDisplayValue(value)
  }, [value, refreshDisplayValue])

  const handleSave = async () => {
    if (val === value) {
      handleCancel()
      return
    }

    setCancelOnBlur(false)
    setIsLoading(true)

    const obj: Record<string, any> = {}
    obj[name] = val

    if (!val || val === '' || val.length === 0) {
      await api.delete(`${url}/${name}`)
    } else {
      await api.patch(url, obj)
    }

    await refreshDisplayValue(val)

    setIsLoading(false)
    setEditMode(false)
    onSuccess && onSuccess(name, val)
  }

  const handleCancel = () => {
    setCancelOnBlur(false)
    setVal(value)
    setEditMode(false)
    setIsLoading(false)
  }

  if (editMode) {
    return (
      <tr>
        <th className={divider ? 'solidBorderTop' : ''}>{label}</th>
        <td
          className={divider ? 'solidBorderTop' : ''}
          style={{ paddingTop: 4, textAlign: `right` }}
        >
          <UserSelect
            onChange={(userId) => setVal(userId)}
            name={name}
            fluid={true}
            placeholder={placeholder}
            value={val}
            disabled={isLoading}
          />

          <div style={{ marginTop: 10 }}>
            <Button
              content="Cancel"
              size="tiny"
              onClick={handleCancel}
              style={{ padding: `9px 13px` }}
              disabled={isLoading}
              onMouseOver={() => setCancelOnBlur(true)}
              onMouseOut={() => setCancelOnBlur(false)}
            />

            <Button
              color="black"
              content="Save"
              size="tiny"
              style={{ padding: `9px 20px`, marginRight: 0 }}
              onClick={handleSave}
              loading={isLoading}
              onMouseOver={() => setCancelOnBlur(true)}
              onMouseOut={() => setCancelOnBlur(false)}
            />
          </div>
        </td>
      </tr>
    )
  }

  if (!val) {
    return (
      <tr
        onClick={() => setEditMode(true)}
        onMouseEnter={() => setShowAdd(true)}
        onMouseLeave={() => setShowAdd(false)}
        style={{ cursor: 'pointer' }}
      >
        <th>{label}</th>
        <td>
          {showAdd && (
            <span style={{ color: 'var(--primary)' }}>+ Add value</span>
          )}
        </td>
      </tr>
    )
  }

  return (
    <tr
      onMouseEnter={() => setShowEdit(true)}
      onMouseLeave={() => setShowEdit(false)}
    >
      <th>{label}</th>
      <td style={{ position: 'relative' }}>
        {displayValue && (
          <UserName>
            {displayValue.image && <UserImage src={displayValue.image} />}
            {displayValue.name}
          </UserName>
        )}

        {/* <ShowIf if={displayValue}>
          
          {displayValue.name}
        </ShowIf> */}

        <TrCopyButton
          visible={showEdit}
          value={displayValue && displayValue.name}
        />
        <TrEditButton onClick={() => setEditMode(true)} visible={showEdit} />
      </td>
    </tr>
  )
}

export default TrUserSelect
